import CommonService from "@/domain/dataTable/commonService/CommonService.js";
import Axios from "axios";

export default class NfseService extends CommonService {
  getNfse(page, qntdNfe, empresa, range, urlFiltros, tipo) {
    // console.log("NFSE-e", urlFiltros);
    let url =
      "nfses/empresa/" +
      empresa +
      "?_page=" +
      page +
      "&_pagesize=" +
      qntdNfe +
      "&_range=" +
      range +
      "&tipo=" +
      tipo;
    urlFiltros != undefined ? (url += urlFiltros) : "";
    return this._resource.get(url).then(
      success => {
        // console.log(success.body);
        return success.body;
      },
      failed => {
        console.log(failed);
      }
    );
  }
  getXml(id_nota) {
    return this._resource.get("nfses/xml/" + id_nota).then(
      success => {
        console.log("xml");
        console.log(success.body);
        return success.body.xml;
      },
      failed => {
        console.log(failed);
      }
    );
  }
  getPdf(pathPdf) {
    return this._resource.get("nfses/pdf/" + pathPdf).then(
      success => {
        var data = new Uint8Array(success.body.pdf.data);
        return this.bufferToBase64(data);
      },
      failed => {
        console.log(failed);
      }
    );
  }
  async sendPdfRobo(id_empresa, file, name,codMun) {
    const data = new FormData();
    data.append("file", file);
    data.append("codMun", codMun);
    data.append("name", name);

    // let url = `https://api.motorfiscal.com.br/upload/${id_empresa}`;

    return this._resource.post(`upload/${id_empresa}`, data).then(
      success => {
        return success;
      },
      failed => {
        return failed;
      }
    );

    // return Axios.post(url, data).then(
    //   success => {
    //     return success;
    //   },
    //   failed => {
    //     return failed;
    //   }
    // );
  }
  getPdfById(id,motor=false) {
    if (motor){
      return this._resource.get("nfses/pdf/" + id).then(
      success => {
        var data = new Uint8Array(success.body.pdf.data);
        return this.bufferToBase64(data);
      },
      failed => {
        console.log(failed);
      }
      );
    }else{
      return this._resource.get("nfses/pdfMotor/" + id).then(
      success => {
        var data = new Uint8Array(success.body.pdf.data);
        return this.bufferToBase64(data);
      },
      failed => {
        console.log(failed);
      }
      );
    }
    
  }
  
  consultaAvulsaNota(id_empresa, tipo) {
    // ?_dtInicio=2018-05-01&_dtFim=2018-05-30&_emitida=true
    const today = new Date()
      .toLocaleDateString()
      .split("/")
      .reverse()
      .join("-");
    const yersterday = new Date(Date.now() - 864e5)
      .toLocaleDateString()
      .split("/")
      .reverse()
      .join("-");
    let tipoUrl = "";
    if (tipo == "emitida") {
      tipoUrl = "_emitida=" + true;
    } else {
      tipoUrl = "_recebida=" + true;
    }
    return this._resource
      .get(
        `nfses/busca/${id_empresa}?_dtInicio=${yersterday}&_dtFim=${today}&${tipoUrl}`
      )
      .then(
        success => {
          console.log("Consulta Avulsa");
          console.log(success);
          return success;
        },
        failed => {
          return failed;
          console.log(failed);
        }
      );
  }

  enviarPlanilha(file, idEmpresa) {
    return this._resource.post(`nfses/emissaobh/importaPlanilha/${idEmpresa}`, file).then(
      success => {
        return success;
      },
      failed => {
        return failed;
      }
    );
  }

  enviarPlanilhaEscrituracao(file, idEmpresa) {
    return this._resource.post(`nfses/escrituracao/importaPlanilha/${idEmpresa}`, file).then(
      success => {
        return success;
      },
      failed => {
        return failed;
      }
    );
  }

  getNfseEmitidas(page, qntdNfe, empresa, range, urlFiltros, tipo) {
    let url = '';
    if(range !== 'falhas') {
      url =
      "nfses/empresa/" +
      empresa +
      "?_page=" +
      page +
      "&_pagesize=" +
      qntdNfe +
      "&_range=" +
      range +
      "&tipo=" +
      tipo + 
      "&_nfsebh=true";
      urlFiltros != undefined ? (url += urlFiltros) : "";
    }else {
      url = `nfses/emissaobh/falha/${empresa}?_page=${page}&_pagesize=${qntdNfe}`;
    }
    return this._resource.get(url).then(
      success => {
        
        return success.body;
      },
      failed => {
        return failed.body;
      }
    );
  }

  async inserirNovaNota(nfse, idEmpresa) {
    return this._resource.post(`nfses/emissaobh/${idEmpresa}`, nfse).then(
      success => {
        return success.body;
      },
      failed => {
        return failed.body;
      }
    );
  }

  async atualizarNota(nfse, notaId) {
    return this._resource.put(`nfses/emissaobh/${notaId}`, nfse).then(
      success => {
        return success.body;
      },
      failed => {
        return failed.body;
      }
    );
  }

  async uploadDes(file, idEmpresa) {
    return this._resource.post(`nfses/validaDes/${idEmpresa}`, file).then(
      success => {
        return success;
      },
      failed => {
        return failed;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/notas/nfse/NfseService.js